import { getCloudinaryRawUrl, TEAM_LINE } from "@swiggy-private/js-utils";
import { captureError } from "@core-ui/utils/Error";

export const fetchLottie = async ({
    lottieId,
    setLottieData,
    setLottieFailed,
}: {
    lottieId?: string;
    setLottieData: React.Dispatch<React.SetStateAction<null>>;
    setLottieFailed: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const lottieUrl = getCloudinaryRawUrl(lottieId ?? "", {}, { teamLine: TEAM_LINE.PORTAL }) ?? "";

    try {
        const lottieResponse = await fetch(lottieUrl);
        setLottieData(await lottieResponse.json());
    } catch (error) {
        captureError(error);
        setLottieFailed(true);
    }
};
